export namespace ObjectConstants {
  export const USER = 'User';
  export const PERSON = 'Person';
  export const RIDE_REQUEST = 'RideRequest';
  export const RESERVATION = 'Reservation';
  export const FARE_CALCULATION = 'FareCalculation';
  export const ORGANIZATION_RIDER = 'OrganizationRider';
}
